import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main__section reset-password__completed" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, " 패스워드가 변경되었습니다. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", null, _toDisplayString(_ctx.userName), 1),
      _hoisted_3
    ])
  ]))
}